<h3>鶏種登録（
  <span *ngIf="willAdd else exist">新規追加</span>
  <ng-template #exist><span>既存のマスタから選択</span></ng-template>
  ）
</h3>
<mat-slide-toggle style="margin-bottom: 20px" [(ngModel)]="willAdd">
  新規作成</mat-slide-toggle>
<ng-container *ngIf="willAdd">
  <div fxLayout="column" fxLayoutGap="10px">
    <ng-container *ngIf="(speciesObservable | async) as species">
      <ng-select style="width: 200px;"
                 [items]="species
                    | isDeletedFilter:false
                    | listFilter:'shiyuu': chumonService.getShiyuu(data.osuMesu): false"
                 bindLabel="name"
                 placeholder="鶏種"
                 [closeOnSelect]="true"
                 [multiple]="false"
                 [(ngModel)]="selectedSpecies"
                 appendTo="body"
                 name="selectedSpecies"></ng-select>
    </ng-container>
    <mat-form-field style="width: 200px" >
      <mat-label>
        鶏種略称
      </mat-label>
      <input matInput required placeholder="鶏種略称" disabled
             name="keishuRyakushou" [(ngModel)]="newKeishu.keishuRyakushou">
    </mat-form-field>
    <div fxLayout="row">
      <button mat-button color="primary" [disabled]="!selectedSpecies"
              (click)="register();">登録
      </button>
      <span class="fill-remaining-space"></span>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="!willAdd">
  <ng-select style="width: 200px;"
             [items]="masterService.keishuMaster
                    | isDeletedFilter:false
                    | listFilter:'shiyuu': chumonService.getShiyuu(data.osuMesu): false"
             bindLabel="name"
             placeholder="鶏種"
             [closeOnSelect]="true"
             [multiple]="false"
             [(ngModel)]="selectedKeishu"
             appendTo="body"
             name="selectedKeishu"></ng-select>
  <div fxLayout="row">
    <button mat-button color="primary" [disabled]="!selectedKeishu"
            (click)="selectExistingValue();">変更
    </button>
    <span class="fill-remaining-space"></span>
  </div>
</ng-container>
